@if (searchListColumns) {
  <div>
    <rask-container-block>
      <ng-container header>{{texts.produktinstruktioner}}</ng-container>
      <div class="row">
        <rask-list [data]="produktspecifikation.produktinstruktioner" class="col-6" aid="produktinstruktionerList">
          <rask-list-column [header]="texts.namn" field="namn" width="250px"></rask-list-column>
        <rask-list-column [header]="texts.puid" field="puid" width="230px">
            <ng-template let-row="row">
            <a [routerLink]="['/produktinstruktioner', row.puid]">
                {{row.puid}}
            </a>
            <a  [routerLink]="['/produktinstruktioner', row.puid]"
                target="_blank">
                <i class="far fa-sm fa-external-link p-r-half"></i>
            </a>
            </ng-template>
        </rask-list-column>
          <rask-list-column [header]="texts.version" field="version" width="100px"></rask-list-column>
          <rask-list-column [header]="texts.laddaNedPin" field="puid" width="50px" [centered]="true">
            <ng-template let-value>
              <a href="javascript:void(0)" (click)="downloadPinFile(value, false)" class="btn btn-lg btn-icon">
                <span class="fas fa-download"></span>
              </a>
            </ng-template>
          </rask-list-column>
            <rask-list-column [header]="texts.laddaNedPinv3" field="puid" width="50px" [centered]="true">
              <ng-template let-value>
                <a href="javascript:void(0)" (click)="downloadPinFile(value, true)" class="btn btn-lg btn-icon">
                  <span class="fas fa-download"></span>
                </a>
              </ng-template>
            </rask-list-column>
          @if (canEdit) {
            <rask-list-column header="Ta bort koppling" field="id" width="50px" [centered]="true">
              <ng-template let-value>
                <rask-button color="tertiary" target="_blank" negative icon="far fa-trash-alt" (click)="unlinkProduktinstruktion(value)">
                </rask-button>
              </ng-template>
            </rask-list-column>
          }
        </rask-list>
      </div>
    </rask-container-block>
    <rask-container-block>
      <ng-container header>{{texts.sokProduktinstruktion}}</ng-container>
      <div class="d-flex">
        <rask-input aid="sortimentsExterntInput" [label]="texts.sortiment" [(ngModel)]="produktinstruktionSearchParams.sortimentExternt"></rask-input>
        <rask-input aid="namnInput" [label]="texts.namn" [(ngModel)]="produktinstruktionSearchParams.namn"></rask-input>
        <rask-input aid="puidInput" [label]="texts.puid" [(ngModel)]="produktinstruktionSearchParams.puid"></rask-input>
        <rask-input aid="mottagningsplatsExterntInput" [label]="texts.mottplats" [(ngModel)]="produktinstruktionSearchParams.mottagningsplatsExternt"></rask-input>
        <rask-button
          aid="searchForProdukinstruktionerButton"
          color="secondary"
          class="align-search-buttons"
          (click)="searchForProduktinstruktioner()">
          {{texts.sok}}
        </rask-button>
        <rask-button
          aid="clearProduktinstuktionSearchFiltersButton"
          color="secondary"
          negative
          class="align-search-buttons"
          (click)="clearSearchParams()">
          {{texts.rensa}}
        </rask-button>
      </div>
      <hr />
      <div class="row pt-4">
        <div class="col-10">
          @if (produktinstruktionList.length > 0) {
            <rask-table
              [data]="produktinstruktionList"
              [columns]="searchListColumns"
              aid="produktinstruktionerTable">
            </rask-table>
          }
        </div>
      </div>
    </rask-container-block>
  </div>
}
